module.exports = __webpack_public_path__ + "img/text_05.946f0bff.png";